import { VideoRecorder } from './VideoRecorder'

export const videoRecorder = new VideoRecorder()
export const videoToggle = true
